import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GlobeIcon, MenuIcon, SearchIcon } from 'lucide-react';
import { MobileNav } from './MobileNav';
import { candidate, primaryNav } from '../../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <>
      <header className={`sticky top-0 z-[80] transition-[background-color,box-shadow,padding] duration-200 ease-emphasis ${scrolled ? 'bg-ink/95 py-2 shadow-lift backdrop-blur' : 'bg-ink py-3.5'}`} data-id="element-506" data-mp="vqwazkb4ohjx">
        <div className="mx-auto flex max-w-content items-center gap-6 px-4 sm:px-6 lg:px-10" data-id="element-507" data-mp="3ugmlmyd8okl8">
          <Link to="/" className="flex items-baseline gap-2" aria-label={`${candidate.name} for President, home`} data-id="element-508" data-mp="3ues9a8g1a0sr">
            <span className="font-display text-xl font-semibold tracking-[-0.02em] text-white sm:text-[22px]" data-id="element-509" data-mp="bt6z5u4j7ug1">
              {candidate.initials}
            </span>
            <span className="font-sans text-[13px] font-bold tracking-[0.14em] text-gold-400" data-id="element-510" data-mp="ll2x956mbkk9">
              {candidate.cycle}
            </span>
          </Link>

          <nav aria-label="Primary" className="hidden flex-1 lg:block" data-id="element-511" data-mp="3k4jmstwsgwa9">
            <ul className="flex items-center justify-center gap-1" data-id="element-512" data-mp="3p1tj8tili87l">
              {primaryNav.map(item => <li key={item.label} data-id="element-513" data-mp="3tz39gbdt6nwh">
                  <Link to={item.href} className="rounded-md px-3 py-2 text-[14px] font-medium text-white/75 transition-colors duration-150 ease-emphasis hover:bg-white/[0.07] hover:text-white" data-id="element-514" data-mp="1wbyp5op7jz4">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="ml-auto flex items-center gap-1.5 lg:ml-0" data-id="element-515" data-mp="3ae7tkjo8bdx5">
            <Link to="/search" aria-label="Search the site" className="hidden h-10 w-10 items-center justify-center rounded-lg text-white/70 transition-colors duration-150 ease-emphasis hover:bg-white/10 hover:text-white sm:flex" data-id="element-516" data-mp="35d0nqq5ncot4">
              <SearchIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-517" data-mp="2qp75syt39a7d" />
            </Link>
            <button type="button" aria-label="Change language" className="hidden h-10 items-center gap-1.5 rounded-lg px-2.5 text-[13px] font-medium text-white/70 transition-colors duration-150 ease-emphasis hover:bg-white/10 hover:text-white lg:flex" data-id="element-518" data-mp="2mnu4n20xxv6s">
              <GlobeIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-519" data-mp="27wlduplay3s2" />
              EN
            </button>
            <Link to="/support" className="hidden h-11 items-center rounded-lg bg-green-600 px-5 text-[15px] font-semibold text-white transition-colors duration-150 ease-emphasis hover:bg-green-700 sm:inline-flex" data-id="element-520" data-mp="22ya5ykeki3ch">
              Support the Campaign
            </Link>
            <button type="button" onClick={() => setMenuOpen(true)} aria-label="Open menu" aria-expanded={menuOpen} aria-controls="mobile-navigation" className="flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors duration-150 ease-emphasis hover:bg-white/10 lg:hidden" data-id="element-521" data-mp="9hxfxvmnqqfl">
              <MenuIcon aria-hidden className="h-6 w-6" data-id="element-522" data-mp="s6c8wogjcej1" />
            </button>
          </div>
        </div>
      </header>

      <MobileNav open={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-523" data-mp="x7hxqb72rhna" />
    </>;
}